import React, {Component} from 'react'

class Filters extends Component {
s
  render () {

    const filters = this.props.filters.map((f) => {

      return (f.mode)
    } );


    return (
      <div className={'Filter'}>
        {filters}
      </div>
    )
  }
}

export default Filters




// WEBPACK FOOTER //
// ./src/js/components/Filters/Filters.jsx